import React from 'react';
import { get } from 'lodash-es';
import { BUTTON_SIZE } from '@/config/ui/button';
import { POPUP_HEIGHT } from '@/config/ui/popup';
import { ForwardButton } from '../../component/atom/Button';
import ChoiceChip from '../../component/atom/ChoiceChip';
import Popup from '../../component/composite/Popup';
import { S } from '../util/style';
import { POPUP_TYPE } from '../../config/popup';
const renderPopupBody = ({ symptomOptionList, symptom, handleChoiceChipClick, getIsChoiceChipSelected, }) => (<S.PopupBody>
    <S.PopupBodyLayoutGrid>
      {symptomOptionList.map((symptomOption) => {
        const optionValue = get(symptomOption, 'displayTitle', '');
        return (<ChoiceChip key={optionValue} isSelected={getIsChoiceChipSelected({ symptom, optionValue })} content={optionValue} onChipClick={() => handleChoiceChipClick({ optionValue })}/>);
    })}
    </S.PopupBodyLayoutGrid>
  </S.PopupBody>);
const renderPopupFooter = ({ isForwardButtonAvailable, handleForwardButtonClick, }) => (<S.PopupFooterWithNotes>
    <S.PopupFooterNotes>＊可複選</S.PopupFooterNotes>
    <ForwardButton onButtonClick={handleForwardButtonClick} isAvailable={isForwardButtonAvailable} size={BUTTON_SIZE.MEDIUM}>
      確定
    </ForwardButton>
  </S.PopupFooterWithNotes>);
export default function View({ 
// data
popupType, symptomOptionList, symptom, isForwardButtonAvailable, 
// func
setPopupType, handleChoiceChipClick, handleForwardButtonClick, getIsChoiceChipSelected, }) {
    return (<Popup isSlideIn={popupType === POPUP_TYPE.SYMPTOM} closePopup={() => setPopupType(POPUP_TYPE.CLOSE)} height={POPUP_HEIGHT.LARGE} title='目前病症' popupBody={renderPopupBody({
            symptomOptionList,
            symptom,
            handleChoiceChipClick,
            getIsChoiceChipSelected,
        })} popupFooter={renderPopupFooter({ isForwardButtonAvailable, handleForwardButtonClick })}/>);
}
